<p-toolbar class="custom-header">
    <div class="p-toolbar-group-start hidden sm:block" style="flex-basis: 35%; ">
        <custom-input-simple
            [value]="searching"
            (parentFunction)="search($event)"
            placeholder="Buscar en Onemall"
        ></custom-input-simple>
    </div>
    <div class="p-toolbar-group-center" routerLink="/">
        <img src="assets/images/logo.png" height="85" class="cursor-pointer"/>
    </div>
    <div class="p-toolbar-group-end" style="flex-basis: 35%; justify-content: flex-end;">
      <ng-template #login>
        <div class="hidden  sm:block">
          <custom-button
            (click)="goToLogin()"
            label="Acceder"
            icon="pi pi-user"
            [text]="true"
          ></custom-button>
        </div>
      </ng-template>
      <div class="sm:hidden">
        <p-button *ngIf="!isLoggedUser"
          icon="pi pi-sign-in"
          styleClass="p-button-lg p-button-rounded p-button-info p-button-text"
          (click)="goToLogin()"
          [pTooltip]="'Ingresar'"
          tooltipPosition="top"
          [text]="true">
        </p-button>
      </div>

      <p-button
        icon="pi pi-shopping-cart"
        styleClass="p-button-lg p-button-rounded p-button-info p-button-text"
        [routerLink]="['/shopping-car']"
        [pTooltip]="'ir al Carrito'"
        tooltipPosition="top"
        [text]="true">
      </p-button>
      <p-button *ngIf="isLoggedUser"
        icon="pi pi-sign-out"
        styleClass="p-button-lg p-button-rounded p-button-info p-button-text"
        (click)="logOut()"
        [pTooltip]="'Salir'"
        tooltipPosition="top"
        [text]="true">
      </p-button>
        <div class="hidden flex flex-column" *ngIf="isLoggedUser; else login ">
        <i class="pi pi-user"
          [pTooltip]="'Bienvenido ' + user.name + ' ' + user.lastName "
          tooltipPosition="top"
          style="color: #3b82f6;"
          [ngStyle]="{fontSize: '1.25rem'}"

        >
        </i>
      </div>
    </div>
</p-toolbar>

<div class="customMenuPopup flex  justify-content-between ">
  <div class="p-toolbar-group-start  sm:hidden">
    <custom-input-simple
      [value]="searching"
      (parentFunction)="search($event)"
      placeholder="Buscar en Onemall"
    ></custom-input-simple>
  </div>
  <p-menu #menu [model]="optionsPop" [popup]="true"></p-menu>
  <button class="sm:hidden text-white" [text]="true" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars"  ></button>
</div>

<p-tabMenu
    [model]="options"
    [activeItem]="activeOption"
    (activeItemChange)="onActiveItemChange($event)"
></p-tabMenu>
